import createAxiosInstance from "../utils/axiosInstance";
import Env from "../env/Env";

const request = createAxiosInstance(`${Env.API_BASE}/api/internal/jobs`);

export interface QueueJob {
  id: string | number;
  name: string;
  state: string;
  /** Human-readable description from the API (e.g. dashboard-1-cache-warmup). */
  taskLabel?: string;
  progress?: number;
  attemptsMade?: number;
  failedReason?: string;
  timestamp?: number;
  processedOn?: number;
  finishedOn?: number;
}

export interface QueueStatusResponse {
  success: boolean;
  queue: string;
  counts: Record<string, number>;
  query: { limit: number };
  jobsByState: {
    active: QueueJob[];
    waiting: QueueJob[];
    delayed: QueueJob[];
    failed: QueueJob[];
    completed: QueueJob[];
  };
}

const queueAPIsService = {
  getQueueStatus: (limit: number = 50, signal?: AbortSignal): Promise<QueueStatusResponse> => {
    return new Promise((resolve, reject) => {
      request
        .get("/", {
          params: { limit },
          signal,
        })
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err?.response?.data || err));
    });
  },

  deleteJob: (jobId: string | number): Promise<{ success: boolean; message?: string; jobId?: string }> => {
    return new Promise((resolve, reject) => {
      request
        .delete(`/${encodeURIComponent(String(jobId))}`)
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err?.response?.data || err));
    });
  },

  requeueJob: (jobId: string | number): Promise<{ success: boolean; message?: string; jobId?: string; newJobId?: string }> => {
    return new Promise((resolve, reject) => {
      request
        .post(`/${encodeURIComponent(String(jobId))}/requeue`)
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err?.response?.data || err));
    });
  },

  resetQueue: (): Promise<{
    success: boolean;
    message?: string;
    removed?: Record<string, number>;
    counts?: Record<string, number>;
    warnings?: string[];
  }> => {
    return new Promise((resolve, reject) => {
      request
        .post("/reset")
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err?.response?.data || err));
    });
  },
};

export default queueAPIsService;
